var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-bar-top',{attrs:{"icons-are-hidden":"","is-primary":""}}),_c('div',{staticClass:"container has-nav-top-margin"},[_c('section',{staticClass:"section sign-up-form-container"},[_c('sign-up-candidate-form-card')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }